module.exports = __webpack_public_path__ + "img/wheelchair.5e431de0.svg";